/* Stienhardt - keep the Diamond Specifications toggle icon honest (2026-06-27)
   The theme's accordion handler sometimes leaves `.active` on `.sp-stone-spec-h`
   after the content closes -> the X icon stays instead of reverting to +. Drive
   the header's `.active` from whether the content is actually visible.
   Revert = remove file + script. */
(function () {
  'use strict';
  function sync() {
    document.querySelectorAll('.accordion-header.sp-stone-spec-h').forEach(function (h) {
      var c = h.nextElementSibling;
      if (!c || !c.classList.contains('accordion-content')) return;
      var open = c.style.display !== 'none' && getComputedStyle(c).display !== 'none' && c.offsetHeight > 1;
      if (h.classList.contains('active') !== open) h.classList.toggle('active', open);
    });
  }
  function boot() {
    var hs = document.querySelectorAll('.accordion-header.sp-stone-spec-h');
    if (!hs.length) { setTimeout(boot, 300); return; }
    hs.forEach(function (h) {
      var c = h.nextElementSibling;
      if (c) new MutationObserver(function () { setTimeout(sync, 60); }).observe(c, { attributes: true, attributeFilter: ['style'] });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.accordion-header.sp-stone-spec-h')) {
        [400, 650, 1000].forEach(function (t) { setTimeout(sync, t); });
      }
    });
    sync();
  }
  boot();
})();
